import type { Routes } from '@angular/router';

export const SEO_POSTS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/restaurants/seo-layout/seo-posts-layout/seo-posts-layout.component').then(
                (m) => m.SeoPostsLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'list',
            },
            {
                path: 'list',
                loadComponent: () =>
                    import('#modules/posts/views/seo-posts-list/seo-posts-list.component').then((m) => m.SeoPostsListComponent),
            },
        ],
    },
];
